
// frontend/geopolitikia/src/components/CountryActionPopin.jsx
import React from 'react';
import {
  Shield,
  Swords,
  MapPin,
  User,
  Zap,
  Users
} from "lucide-react";

const CountryActionPopin = ({ selectedCountryPopin, handleClosePopin, addMapAction, removeMapAction, canPerformAction }) => {
  if (!selectedCountryPopin) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={handleClosePopin}>
      <div className="bg-slate-800/95 backdrop-blur-sm text-white p-4 rounded-xl shadow-2xl border border-slate-600 max-w-xs" onClick={(e) => e.stopPropagation()}>
        <div className="space-y-3">
          <div className="flex items-center gap-2 font-semibold text-blue-300">
            <img className="flag" src={require(`../assets/flags/${selectedCountryPopin.countryShortName}.png`)} alt={`Drapeau ${selectedCountryPopin.countryShortName}`} />
            {selectedCountryPopin.countryShortName}
          </div>

          <div className="grid grid-cols-1 gap-2 text-sm">
            <div className="flex items-center gap-2">
              {selectedCountryPopin.status === 'allies' && <Shield size={14} className="text-emerald-400" />}
              {selectedCountryPopin.status === 'ennemi' && <Swords size={14} className="text-red-400" />}
              {selectedCountryPopin.status === 'neutre' && <MapPin size={14} className="text-slate-400" />}
              {selectedCountryPopin.status === 'joueur' && <User size={14} className="text-blue-400" />}
              <span>Relation: </span>
              <span className={`font-medium ${selectedCountryPopin.status === 'allies' ? 'text-emerald-300' :
                selectedCountryPopin.status === 'ennemi' ? 'text-red-300' :
                  'text-slate-300'
                }`}>
                {selectedCountryPopin.status}
              </span>
            </div>

            <div className="flex items-center gap-2">
              <Users size={14} className="text-blue-400" />
              <span>Population: </span>
              <span className="font-medium text-blue-300">{selectedCountryPopin.data.population}</span>
            </div>


            <div className="flex items-center gap-2">
              <Zap size={14} className="text-yellow-400" />
              <span>Ressources: </span>
              <span className="font-medium text-yellow-300">{selectedCountryPopin.data.natural_resources}%</span>
            </div>


            {selectedCountryPopin.lose && (
              <div className="text-red-300 font-medium flex items-center gap-2">
                <span>❌</span>
                <span>Pays éliminé</span>
              </div>
            )}
          </div>
          {selectedCountryPopin.status !== 'joueur' && !selectedCountryPopin.currentActionHex && canPerformAction && (
            <div className="mt-4 flex gap-2">
              <button onClick={() => { addMapAction('Attaquer', selectedCountryPopin.countryShortName); handleClosePopin(); }} className="flex-1 bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors">
                <Swords size={16} />
                Attaquer
              </button>
              <button onClick={() => { addMapAction('Défendre contre', selectedCountryPopin.countryShortName); handleClosePopin(); }} className="flex-1 bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors">
                <Shield size={16} />
                Défendre
              </button>
            </div>
          )}
          {selectedCountryPopin.status !== 'joueur' && selectedCountryPopin.currentActionHex && (
            <div className="mt-4 flex gap-2">
              <button onClick={() => { removeMapAction(selectedCountryPopin.countryShortName); handleClosePopin(); }} className="flex-1 bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors">
                <User size={16} />
                Annuler
              </button>
            </div>
          )}
          <button onClick={handleClosePopin} className="w-full mt-4 bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-lg transition-colors">
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default CountryActionPopin;
